export const prefix = '/appeals';
export const AppealsRoutes = {
  AppealsSearch: `${prefix}/search`,
  AppealSummary: `${prefix}/:id/summary`,
  AppealOwnerAgentPresentation: `${prefix}/:id/ownerAgentPresentation`,
  AppealSmartLists: `${prefix}/smart-lists`,
  CreateAppealWalkthru: `${prefix}/create/walkthrough/:propertyId?`,
  Dashboard: `${prefix}/dashboard`,
  WaitingRoomFormal: `${prefix}/waitingroomformal`,
  WaitingRoomInformal: `${prefix}/waitingroominformal`,
  WaitingRoomFormalCheckIn: `${prefix}/waitingroomformal/:roomID/:id`,
  WaitingRoomInformalCheckIn: `${prefix}/waitingroominformal/:roomID/:id`,
  PanelOverview: `${prefix}/panel-overview`,
  PanelOverviewFormalCheckIn: `${prefix}/panel-overview-formal/:roomID/:id`,
  PanelOverviewInformalCheckIn: `${prefix}/panel-overview-informal/:roomID/:id`,
  ManagerOverview: `${prefix}/manager-overview`,
  AppraiserOverview: `${prefix}/appraiser-overview`,
  AppraiserOverviewFormalCheckIn: `${prefix}/appraiser-overview-formal/:roomID/:id`,
  AppraiserOverviewInformalCheckIn: `${prefix}/appraiser-overview-informal/:roomID/:id`,
  Meeting: `${prefix}/meeting`,
  SelectedHearing: `${prefix}/selected-hearing`,
  MassCreateAppeal: `${prefix}/mass-create`,
  ResetPrimaryProtester: `${prefix}/reset-primary-protester`,
  AddAuthorizedAgentProtest: `${prefix}/add-authorized-agent-protest`,
  InformalMeetingImport: `${prefix}/informal-meeting-import`,
  FormalMeetingImport: `${prefix}/formal-meeting-import`,
  DocketsSearch: `${prefix}/dockets/search`,
  AssignPanels: `${prefix}/dockets/assign-panels`,
  BoardMemberMaintenance: `${prefix}/board-member-maintenance/:memberId?`,
  PanelMaintenance: `${prefix}/panel-maintenance/:panelId?`,
  DocketLocations: `${prefix}/docket-locations/:locationId?`,
  StatusCodes: `${prefix}/status-codes/:appealStatusId?`,
  FinalLetterHistory: `${prefix}/history/final-letter`,
  MassLetterHistory: `${prefix}/history/mass-letter`,
  FinalLetterDetail: `${prefix}/history/final-letter/:massLetterId`,
  MassFinalizeHistory: `${prefix}/history/mass-finalize`,
  MassProcessHistory: `${prefix}/history/mass-process`,
  MassAttachHistory: `${prefix}/history/mass-attach`,
  EvidenceUploadHistory: `${prefix}/history/evidence-upload`,
  MassDownloadHistory: `${prefix}/history/mass-download`,
  MassAoaHistory: `${prefix}/history/mass-aoa`,
  AppealConfigurations: `${prefix}/configurations`,
  AppealsCommercialConfiguration: `${prefix}/commercial/configuration`,
  EletronicDeliveryNoticeSetting: `${prefix}/electronic-delivery-notice-setting`,
  AppealsCommercialArtifacts: `${prefix}/commercial/artifacts`,
  AppealsCommercialComponents: `${prefix}/commercial/components`,
  AgentDocketGroupSearch: `${prefix}/agent-docket/search`,
  TaxpayerPresentationView: `${prefix}/tax-payer-presentation`,
  CadPresentationView: `${prefix}/cad-presentation`,
  PanelStatisticsView: `${prefix}/panel-statistics`,
  CopyFormalHearing: `${prefix}/copy-formal-hearing/:appealId/:mode`,
  AgentMassDownloadValidation: '/appeals/agent-mass-download-validation',
};
